import { render, staticRenderFns } from "./DictionaryComp.vue?vue&type=template&id=7b785837&"
import script from "./DictionaryComp.vue?vue&type=script&lang=js&"
export * from "./DictionaryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports